import _ from "lodash";
import { MoUtils } from "ui-common";
import { LwRelatedContentProbe } from "../components/lw-related-content/interfaces";
import { LwFacetConfig, LwResultsConfig, LwSearchaheadConfig } from "../interfaces";
import { LwOverviewConfig } from "../components/lw-overview/interfaces";

export type EmbeddableConfig = LwSearchaheadConfig | LwFacetConfig | LwResultsConfig | LwRelatedContentProbe | LwOverviewConfig;

export const getConfig = (rawConfig: EmbeddableConfig | string) => {
  return parseConfig(rawConfig);
};

export const parseConfig = (config) => {
  return MoUtils.safeParseJSON(config, 'Invalid config passed to embeddable component.');
};

export const convertDeepLinkingPropToObject = (context, prop: string) => {
  const propValue= context[prop];
  let decodedObject = null;

  if (!_.isEmpty(propValue)) {
    try {
      decodedObject = JSON.parse(decodeURIComponent(propValue));
    } catch(error) {
      const urlParamKey = _.get(context, `deepLinkingStates.${prop}`);

      console.warn(`Failed to convert query param to object.\n\n Query Param Key: "${urlParamKey}":\n Query Param Value: ${propValue}\n\n Error:`, error, '\n\nComponent:', context.constructor.name);
    }
  }

  return decodedObject;
};

/**
 * Get the value from the element based on the target path.
 */
export const extractElementValue = (targetPath, element) => {
  const [selector, target] = targetPath.split('@');
  const isSelf = _.trim(selector) === ':scope';
  const valueElement = isSelf ? element : element.querySelector(selector);
  let value;

  if (valueElement) {
    if (target ==='text') {
      value = valueElement.textContent;
    } else if (['href', 'src', 'value'].includes(target)) {
      value = valueElement[target];
    } else {
      value = valueElement.getAttribute(target);
    }

    value = value?.replace(/\n/g, '')?.replace(/\s+/g, ' ') ?? value;
  }

  return value;
};